/*
 * @Author: wangkg wangkegui@longfor.com
 * @Date: 2022-09-24 21:15:03
 * @LastEditors: wangkg wangkegui@longfor.com
 * @LastEditTime: 2022-12-23 07:47:54
 * @FilePath: /low-code/src/store/index.js
 * @Description: 
 */
import Vue from 'vue'
import {createStore} from 'vuex'
import appBase from './modules/appBase'
import memInfo from './modules/memInfo'
import user from './modules/user'
import app from './modules/app'
import getters from './getters'

// 平台侧
import common from './modules/move-auth/platform/common'
import organization from './modules/move-auth/platform/organization'
import sysUserManagement from './modules/move-auth/platform/sysUserManagement'
import sysRolesManagement from './modules/move-auth/platform/sysRolesManagement'
import permission from './modules/move-auth/platform/permission'
// 应用侧
import appCommon from './modules/move-auth/app/common'
import appOrganization from './modules/move-auth/app/organization'
import appSysUserManagement from './modules/move-auth/app/sysUserManagement'
import appSysRolesManagement from './modules/move-auth/app/sysRolesManagement'
import appPermission from './modules/move-auth/app/permission'

const store = createStore({
  modules: {
    appBase,
    app,
    memInfo,
    user,
    // 平台侧
    common,
    organization,
    sysUserManagement,
    sysRolesManagement,
    permission,
    // 应用侧
    appCommon,
    appOrganization,
    appSysUserManagement,
    appSysRolesManagement,
    appPermission
  },
  getters
})

export default store
